export default [
    {
        type: "uni",
        id: 1,
        items: [
            {
                id: 1,
                text: "Der Dozent/Die Dozentin war engagiert und motiviert.",
            },
            {
                id: 2,
                text: "Der Dozent hat die Inhalte angemessen wiederholt.",
            },
            {
                id: 3,
                text: "Ich konnte dem Tempo des Dozenten/der Dozentin gut folgen.",
            },
            {
                id: 4,
                text: "Der Dozent/Die Dozentin ermöglichte eine gute Lern- und Arbeitsatmosphäre.",
            },
            {
                id: 5,
                text: "Der Dozent/Die Dozentin gab die Möglichkeit, Themen zu diskutieren.",
            },
            {
                id: 6,
                text: "Der Dozent/Die Dozentin war stets gut vorbereitet.",
            },
            {
                id: 7,
                text: "Der Dozent/Die Dozentin war fachlich kompetent.",
            },
            {
                id: 8,
                text: "Der Dozent/Die Dozentin konnte Kompliziertes verständlich machen.",
            },
            {
                id: 9,
                text: "Dem Dozenten/Der Dozentin war es wichtig, dass die Teilnehmer/innen etwas lernen.",
            },
            {
                id: 10,
                text: "Der Dozent/Die Dozentin motivierte die Teilnehmer/innen.",
            },
            {
                id: 11,
                text: "Das Lernziel der Veranstaltung wurde mir deutlich.",
            },
            {
                id: 12,
                text: "Die angestrebten Lernziele der Veranstaltung wurden von vorneherein gut definiert.",
            },
            {
                id: 13,
                text: "Die Veranstaltung war übersichtlich aufgebaut und verständlich.",
            },
            {
                id: 14,
                text: "Der inhaltliche Aufbau der Veranstaltung war logisch/nachvollziehbar.",
            },
            {
                id: 15,
                text: "Durch die mit dem Online-Format verbundene Flexibilität (Ort, Zeit, Lerntempo) konnte ich mich intensiver mit den Vorlesungsinhalten auseinandersetzen als in einer klassischen Präsenzveranstaltung.",
            },
            {
                id: 16,
                text: "Ich habe mich schon vor der Veranstaltung für das Thema interessiert.",
            },
            {
                id: 17,
                text: "Das Thema der Veranstaltung ist als solches relevant.",
            },
            {
                id: 18,
                text: "Ich habe das Gefühl in der Veranstaltung Wichtiges gelernt zu haben.",
            },
            {
                id: 19,
                text: "Das behandelte Thema enthält Bezüge zu meiner späteren Berufstätigkeit.",
            },
            {
                id: 20,
                text: "Die Schwere des Stoffes war angemessen.",
            },
            {
                id: 21,
                text: "Der Umfang des Stoffes war angemessen.",
            },
            {
                id: 22,
                text: "Das Tempo der Veranstaltung war angemessen.",
            },
            {
                id: 23,
                text: "Die Anforderungen der Veranstaltung waren angemessen.",
            },
            {
                id: 24,
                text: "Der Zeitaufwand für die Veranstaltung insgesamt (inkl. Vor- und Nachbereitung) war angemessen.",
            },
            {
                id: 25,
                text: "Insgesamt hat mich die Veranstaltung überfordert.",
            },
            {
                id: 26,
                text: "Insgesamt fand ich die Veranstaltung gut.",
            },
            {
                id: 27,
                text: "In der Veranstaltung habe ich viel gelernt.",
            },
            {
                id: 28,
                text: "Meine Erwartungen an die Veranstaltung wurden erfüllt.",
            },
            {
                id: 29,
                text: "Ich würde die Veranstaltung weiterempfehlen.",
            },
            {
                id: 30,
                text: "Die Onlinematerialien in Moodle sind übersichtlich gestaltet.",
            },
            {
                id: 31,
                text: "Mit Hilfe der Onlinematerialien in Moodle konnte ich den Lernstoff leichter verinnerlichen.",
            },
            {
                id: 32,
                text: "Durch die Angebote auf Moodle wurde mein Interesse am Thema der Veranstaltung gestärkt.",
            },
            {
                id: 33,
                text: "Die Qualität der auf Moodle zur Verfügung gestellten Materialien war gut.",
            },
            {
                id: 34,
                text: "Die Auseinandersetzung mit den Reflexionsfragen trugen zum Verständnis der Inhalte bei.",
            },
            {
                id: 35,
                text: "Die Reflexionsfragen auf Moodle unterstützten mich in meinem Lernprozess.",
            },
            {
                id: 36,
                text: "Die Reflexionsfragen waren für mich gut verständlich.",
            },
            {
                id: 37,
                text: "Der Umfang der Reflexionsfragen hat mich überfordert.",
            },
            {
                id: 38,
                text: "Ich habe die Reflexionsfragen schriftlich bearbeitet.",
            },
            {
                id: 39,
                text: "Es war schwer die Reflexionsfragen zu beantworten.",
            },
            {
                id: 40,
                text: "Die im Rahmen von Online-Aktivitäten zu bearbeitenden Materialien waren für Moodle geeignet.",
            },
            {
                id: 41,
                text: "Während der Online-Aktivitäten habe ich mich gut betreut gefühlt.",
            },
            {
                id: 42,
                text: "Ich hätte mehr gelernt, wenn die online bearbeiteten Themen und Aufgaben im Rahmen von Präsenzterminen behandelt worden wären.",
            },
            {
                id: 43,
                text: "Die weiterführende Literatur (Literaturliste) trug zum Verständnis der Inhalte bei.",
            },
            {
                id: 44,
                text: "Innerhalb des Capstone Projektes wurde ich zur kritischen Auseinandersetzung mit den behandelten Themen angeregt.",
            },
            {
                id: 45,
                text: "Das Capstone Projekt hat mich interessiert.",
            },
            {
                id: 46,
                text: "Das Capstone Projekt war für mich hilfreich.",
            },
            {
                id: 47,
                text: "Das Projekt hat mein Verständnis der Inhalte vertieft.",
            },
            {
                id: 48,
                text: "Der Stoff wurde innerhalb der Capstone Projektes anhand von Beispielen veranschaulicht.",
            },
            {
                id: 49,
                text: "Die Bedeutung der behandelten Themen wurde innerhalb des Capstone Projektes vermittelt.",
            },
            {
                id: 50,
                text: "Das Capstone Projekt hat mir verdeutlich, dass Teamarbeit die kritische Auseinandersetzung mit den Themen fördert.",
            },
            {
                id: 51,
                text: "Hinsichtlich des organisatorischen Ablaufs der Veranstaltung (z.B. Ort, Zeit, Leistungsanforderungen) bin ich gut informiert worden.",
            },
            {
                id: 52,
                text: "Mit der Zugänglichkeit von erforderlichen Lehrmaterialien war ich zufrieden.",
            },
            {
                id: 53,
                text: "Organisatorische Fragen wurden rechtzeitig und ausführlich geklärt.",
            },
            {
                id: 54,
                text: "Der Ablauf der Veranstaltung im Verlauf des Semesters war reibungslos.",
            },
            {
                id: 55,
                text: "Der Umfang des Capstone Projektes hat mich überfordert.",
            },
        ],
    },
    {
        type: "text",
        id: 2,
        items: [
            {
                id: 56,
                text: "Verbesserungsvorschläge:",
            },
        ],
    },
    {
        type: "text",
        id: 3,
        items: [
            {
                id: 57,
                text: "Sonstige Anmerkungen zu der Veranstaltung (Lob/Kritik)",
            },
        ],
    },
    {
        type: "special",
        id: 4,
        items: [
            {
                id: 58,
                text: "Wie lange haben Sie sich wöchentlich ca. mit den Onlinematerialien beschäftigt?",
                label: [
                    {
                        id: 1,
                        text: "Weniger als 1 Stunde",
                    },
                    {
                        id: 2,
                        text: "1-2 Stunden",
                    },
                    {
                        id: 3,
                        text: "3-4 Stunden",
                    },
                    {
                        id: 4,
                        text: "5-6 Stunden",
                    },
                    {
                        id: 5,
                        text: "Mehr als 6 Stunden",
                    },
                ],
            },
        ],
    },
    {
        type: "special",
        id: 5,
        items: [
            {
                id: 59,
                text: "Wie oft haben Sie sich die Online-Vorlesungen angesehen?",
                label: [
                    {
                        id: 1,
                        text: "Einmal jede Vorlesung",
                    },
                    {
                        id: 2,
                        text: "Mehrfach jede Vorlesung",
                    },
                    {
                        id: 3,
                        text: "Einmal jede Vorlesung & einzelne Abschnitte mehrfach",
                    },
                ],
            },
        ],
    },
    {
        type: "age",
        id: 6,
        items: [
            {
                id: 60,
                text: "Alter: ",
            },
        ],
    },
];